const suppliers = {
  toast: {
    error: {
      badResponse: '[Fleet] fehlerhafte Serverantwort',
      create: {},
      edit: {},
    },
    success: {
      create: {
        default: '[Fleet] wurde erfolgreich erstellt',
      },
      edit: {},
    },
  },
  table: {
    headers: {
      name: 'Flottenname',
    },
  },
  create: {
    successToast: {
      message: 'Erfolg! Flotte erstellt!',
    },
    errorToast: {
      message: 'Es ist ein Fehler aufgetreten. Flotte konnte nicht erstellt werden.',
    },
  },

  edit: {
    successToast: {
      message: 'Erfolg! Flotte aktualisiert!',
    },
    errorToast: {
      message: 'Ein Fehler ist aufgetreten. Flotte konnte nicht aktualisiert werden.',
    },
  },

  deleteModal: {
    header: 'Flotten löschen',
    body: 'Sie sind dabei, {{num}} Flotten zu löschen.',
  },

  deleteToast: 'Flotten können nicht gelöscht werden',

  forms: {
    information: {
      rank: {
        header: 'Flottenrang und -punktzahl',
      },
      supplierKpis: {
        header: 'Flotten-KPIs',
      },
    },
  },
  delete: {
    confirmation: {
      header: 'Bestätigung zum Löschen der Flotte',
      body: 'Flotte wurde erfolgreich gelöscht',
    },
  },
};

export default suppliers;
